import type { ButtonProps } from "@/components/ui/button.tsx";
import Icon from "@/components/ui/icon.tsx";
import DownloadLink from "@/features/downloads/components/download-link.tsx";
import { useTranslations } from "@/features/translations/components/translations.tsx";
import { useAppSelector } from "@/redux/store.ts";
import type { Nullable } from "@/types";

type Props = Omit<ButtonProps, "asChild"> & { calculatedSmartNumber: Nullable<string> };
export default function DynamicSpecSheet({ children, calculatedSmartNumber, ...props }: Props) {
    const t = useTranslations();

    const dynamicSpecSheetPath = useAppSelector((state) => state.downloads.dynamicSpecSheetPath);

    const path = calculatedSmartNumber ? dynamicSpecSheetPath.replace("__smartnumber__", calculatedSmartNumber) : null;

    if (!path) return null;

    return (
        <DownloadLink {...props} key={path} fileUrl={path}>
            <Icon name="file-download" />
            {children ?? <span>{t("spec_sheet")}</span>}
        </DownloadLink>
    );
}
